import * as THREE from 'three';
import { Utilities } from '../Utilities';
import { IViewerElement } from './ViewerElement';

export class Walkthrough implements IViewerElement {
  private static readonly WIDTH: number = 100;
  private static readonly HEIGHT: number = 100;
  private static readonly SCALE = 1;
  public position: THREE.Vector2 = new THREE.Vector2();
  private _walkthrough3dObject: THREE.Object3D;
  public name: string;
  public id: string;
  public nextPointId: string;
  public get element3dObject(): THREE.Object3D {
    return this._walkthrough3dObject;
  }
  /**
   * Constructs a new Observation instance with specified properties.
   * @param position - Position on the 3D image.
   * @param id - Unique identifier for the observation.
   * @param nextPointId
   */
  constructor(position: THREE.Vector2, id: string, nextPointId: string, name: string) {
    this.name = name;
    this.id = id;
    this.nextPointId = nextPointId;
    this.position = position;
    this.position.z = 0;
    this._walkthrough3dObject = this.createBillboardRectangleOnSphere();
    this._walkthrough3dObject.name = this.id;
  }

  /**
   * Creates a 3D rectangular billboard on the sphere.
   * @returns The created 3D object representing the observation billboard.
   */
  private createBillboardRectangleOnSphere(): THREE.Object3D {
    const positionOnSphere: THREE.Vector3 = Utilities.KrpanoAthAtvToViewerPosition(
      this.position.x,
      this.position.y,
    );
    positionOnSphere.z *= -1;
    const textureLoader = new THREE.TextureLoader();
    const texture = textureLoader.load('assets/webglViewer/walkthroughArrow.png');

    const imageGeometry = new THREE.PlaneGeometry(Walkthrough.WIDTH, Walkthrough.HEIGHT);
    const imageMaterial = new THREE.MeshBasicMaterial({
      map: texture,
      side: THREE.DoubleSide,
      transparent: true,
    });

    const imageMesh = new THREE.Mesh(imageGeometry, imageMaterial);
    // Set the position on the sphere
    imageMesh.position.copy(positionOnSphere);

    // Adjust rotation based on ath (horizontal) and atv (vertical) coordinates
    imageMesh.rotation.x = -Math.PI / 2;
    imageMesh.rotation.z = THREE.MathUtils.degToRad(-this.position.x + 90); // Add 90 degrees to correct clockwise shift

    imageMesh.position.y += 50;
    imageMesh.scale.set(Walkthrough.SCALE, Walkthrough.SCALE, Walkthrough.SCALE);
    imageMesh.updateMatrixWorld(true);

    return imageMesh;
  }
}
